import { useMutation } from 'react-query'

import { api } from '../../../api'

const removeAdmin = (id: number) => {
  return api.delete(`/admins/${id}`)
}

export const useRemoveAdminMutation = () => {
  return useMutation('remove-admin', (id: number) => removeAdmin(id))
}
